import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getKey } from "../../helpers/sessionKey";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import Spinner from "../../components/Reusable/Spinner";
const DeliveryChargeListComponent = loadable(
  () => import("../../components/DeliveryChargeTable")
);

const DeliveryChargeTable = () => {
  const defaultBranch = getKey("default-branch");
  let defaultBranchParsed;
  if (defaultBranch) {
    try {
      defaultBranchParsed = JSON.parse(defaultBranch);
    } catch (err) {
      console.error("Invalid JSON string in default-branch:", err);
    }
  }
  const { data: serviceTypeData, isLoading } = useGetHook({
    url: APIS.SERVICE_TYPE,
    queryKey: ["service-type"],
    params: {
      limit: 1,
      offset: 0,
      is_active: true,
    },
  });
  const { data: productTypeData, isLoading: isprodtypeLoading } = useGetHook({
    url: APIS.PRODUCT_TYPE,
    queryKey: ["prouduct-type"],
    params: {
      limit: 1,
      offset: 0,
      is_active: true,
    },
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Delivery Charge
        </span>
      </div>
      {isLoading || isprodtypeLoading ? (
        <Spinner />
      ) : (
        <DeliveryChargeListComponent
          defaultBranch={defaultBranchParsed}
          serviceTypeData={serviceTypeData?.results}
          productTypeData={productTypeData?.results}
        />
      )}
    </>
  );
};

export default DeliveryChargeTable;
